/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataStructureGraphIcon20Regular = forwardRef('DataStructureGraphIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 5.25A3.25 3.25 0 0 1 5.25 2h6.5a3.25 3.25 0 0 1 0 6.5H9.813l2.25 3h2.687a3.25 3.25 0 0 1 0 6.5h-6.5a3.25 3.25 0 0 1 0-6.5h1.938l-2.25-3H5.25A3.25 3.25 0 0 1 2 5.25ZM5.25 3.5a1.75 1.75 0 1 0 0 3.5h6.5a1.75 1.75 0 1 0 0-3.5h-6.5Zm3 9.5a1.75 1.75 0 1 0 0 3.5h6.5a1.75 1.75 0 1 0 0-3.5h-6.5Z" })));
});
